// src/store/todayRateSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Fetch today's rate from the backend
export const fetchTodayRate = createAsyncThunk(
  'todayRate/fetchTodayRate',
  async () => {
    console.log('🔍 Fetching rate at:', new Date().toISOString());
    const response = await axios.get(`${BACKEND_URL}/api/money/currency/latest`);
    console.log('📊 Backend response:', response.data);
    return {
      standardRate: response.data.standardRate,
      smileRate: response.data.ratePercentAdjusted,
      tamaRate: response.data.ratePercentAdjusted,
      lastUpdated: response.data.lastUpdated
    };
  }
);

const todayRateSlice = createSlice({
  name: 'todayRate',
  initialState: {
    standardRate: 0,
    smileRate: 0,
    tamaRate: 0,
    lastUpdated: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTodayRate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTodayRate.fulfilled, (state, action) => {
        state.standardRate = action.payload.standardRate
        state.smileRate = action.payload.smileRate
        state.tamaRate = action.payload.tamaRate
        state.lastUpdated = action.payload.lastUpdated;
        state.loading = false;
      })
      .addCase(fetchTodayRate.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

// Selectors
export const selectStandardRate = (state) => state.todayRate.standardRate;
export const selectSmileRate = (state) => state.todayRate.smileRate;
export const selectTamaRate = (state) => state.todayRate.tamaRate;
export const selectLastUpdated = (state) => state.todayRate.lastUpdated;
export const selectLoading = (state) => state.todayRate.loading;
export const selectError = (state) => state.todayRate.error;

// Helper selector that returns the appropriate rate based on shop
export const selectRateByShop = (state, shop) => {
  return shop.toLowerCase() === 'tama' ? state.todayRate.tamaRate : state.todayRate.smileRate;
};

export default todayRateSlice.reducer;
